import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=6e3c7c52&scoped=true&"
import script from "./PageHome.vue?vue&type=script&lang=ts&"
export * from "./PageHome.vue?vue&type=script&lang=ts&"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=6e3c7c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c7c52",
  null
  
)

export default component.exports